import {
  IMPLEMENTATION_PLAN_NAMES,
  STAGES_NAMES,
} from 'components/BusinessToolForm/Sections/ImplementationPlan/utils/form';

import { ol, ul } from '../helpers';

const STAGES_INSTRUCTIONS = {
  [STAGES_NAMES.STAGE]: {
    name: 'Plan de implementación',
    instruction:
      'Al responder preguntas sobre el cronograma del proyecto, siga estos pasos:' +
      ol([
        'Describa las principales etapas, desde el concepto hasta el lanzamiento.',
        'Indique la duración estimada de cada etapa.',
        'Especifique en qué etapa se encuentra actualmente el proyecto.',
      ]),
    exampleOne: ul([
      'Concepto y diseño: 6 meses.',
      'Prototipado y pruebas: 9 meses.',
      'Preparación de la producción: 3 meses.',
      'Marketing y preparación del lanzamiento: 2 meses.',
      'Actualmente, el proyecto se encuentra en la etapa de preparación de la producción.',
    ]),
    exampleTwo: ul([
      'Fase conceptual: 3 meses.',
      'Diseño y prototipado: 6 meses.',
      'Pruebas e iteración: 4 meses.',
      'Finalización y producción: 3 meses.',
      'Actualmente, el proyecto se encuentra en la etapa de pruebas e iteración.',
    ]),
  },
};

export const IMPLEMENTATION_PLAN_SECTION_INSTRUCTIONS = {
  [IMPLEMENTATION_PLAN_NAMES.STAGES]: STAGES_INSTRUCTIONS,
};
